import { render, staticRenderFns } from "./MoleculeProjectSliderThumb.vue?vue&type=template&id=4ab52e04&scoped=true&"
import script from "./MoleculeProjectSliderThumb.vue?vue&type=script&lang=js&"
export * from "./MoleculeProjectSliderThumb.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeProjectSliderThumb.vue?vue&type=style&index=0&id=4ab52e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab52e04",
  null
  
)

export default component.exports